import React, {Component} from 'react'
import {inject, observer} from 'mobx-react'
import { Modal, Form, Row, Col, Input, Select, Button, Spin } from 'antd'
import {withTranslation} from 'react-i18next'
const {TextArea} = Input
@inject('marketingSmsSignatureStore')
@observer
class FormModal extends Component {
  state = {
  }

  formRef = React.createRef()

  componentDidMount() {
    const {marketingSmsSignatureStore, title} = this.props
    const {detailsObj} = marketingSmsSignatureStore
    if (title === 'edit') {
      this.formRef.current.setFieldsValue({
        'marketingGroupId': detailsObj?.marketingGroupId,
        'sign': detailsObj?.sign,
        'description': detailsObj?.description,
      })
    }
  }

  handleOk = () => {
    const {marketingSmsSignatureStore, handleCancel, title} = this.props
    const {detailsObj} = marketingSmsSignatureStore
    this.formRef.current.validateFields().then(fieldsValue => {
      let params = {
        "id": title === 'edit' ? detailsObj?.id : null,
        "marketingGroupId": fieldsValue?.marketingGroupId,
        "sign": fieldsValue?.sign,
        "description": fieldsValue?.description,
      }
      if (title === 'edit') {
        marketingSmsSignatureStore.onAddJobAction({...params, id: detailsObj.id}, title).then(res=> {
          if (res?.data?.code === 0) {
            handleCancel()
          }
        })
      } else {
        marketingSmsSignatureStore.onAddJobAction({...params}).then(res=> {
          if (res?.data?.code === 0) {
            handleCancel()
          }
        })
      }
    }).catch(() => {})
  }

  render() {
    const { marketingSmsSignatureStore, addModalVisible, handleCancel, title, t } = this.props
    const { isFetchingAdd, groupList } = marketingSmsSignatureStore
    return (
      <>
        <Modal
          title={title === 'edit' ? t(`marketingManagement.editSmsSignature`) : t(`marketingManagement.addSmsSignature`)}
          closable={true}
          visible={addModalVisible}
          onCancel={handleCancel}
          maskClosable={false}
          destroyOnClose={true}
          centered
          footer={[
            <Button key="Save" type="primary" onClick={this.handleOk} >{t(`general.save`)}</Button>,
            <Button key="Cancel" onClick={handleCancel}>{t(`general.cancel`)}</Button>,
          ]}
        >
          <Spin spinning={isFetchingAdd}>
            <Form ref={this.formRef} key="addMapping" layout="vertical">
              <Row gutter={[10, 10]}>
                <Col span={24}>
                  <Form.Item name="marketingGroupId" label={t(`marketingManagement.marketingGroup`)}
                    rules={[{required: true, message: `${t(`general.pleaseSelect`)} ${t(`marketingManagement.marketingGroup`)}`}]}
                  >
                    <Select placeholder={t(`general.pleaseSelect`)} allowClear showSearch filterOption={(input, option) =>
                      option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                    }>
                      {groupList?.map(item => (<Select.Option key={item.id} value={item.id}>{item.groupName}</Select.Option>))}
                    </Select>
                  </Form.Item>
                </Col>
                <Col span={24}>
                  <Form.Item name="sign" label={t(`marketingManagement.signature`)} rules={[{
                    required: true,
                    message: `${t(`general.pleaseEnter`)} ${t(`marketingManagement.signature`)} ${t(`marketingManagement.tips`)}`,
                    pattern: new RegExp(/^[\u4E00-\u9FA5A-Za-z0-9-]+$/)
                  }]}>
                    <Input maxLength={18} placeholder='请输入签名内容,最多18个字符' />
                  </Form.Item>
                </Col>
                <Col span={24} >
                  <Form.Item name='description' label={t(`marketingManagement.desc`)} rules={[{ required: false, message: `${t(`general.pleaseEnter`)} ${t(`marketingManagement.desc`)}` }]}>
                    <TextArea rows={4} placeholder="营业执照，公司简称，APP名称，公众号，商标名称，软件著作权（软著），小程序等" style={{width: '100%'}} />
                  </Form.Item>
                </Col>
              </Row>
            </Form>
          </Spin>
        </Modal>
      </>
    )
  }
}

export default withTranslation()(FormModal)
